const agentActionTypes = {
  AGENT_SET_BOT_ERROR: 'AGENT_SET_BOT_ERROR',
  AGENT_FILTER_REQUEST: 'AGENT_FILTER_REQUEST',
  AGENT_FILTER_SUCCESS: 'AGENT_FILTER_SUCCESS',
  AGENT_FILTER_FAILURE: 'AGENT_FILTER_FAILURE',
  AGENT_START_FETCH: 'AGENT_START_FETCH',
  AGENT_SET_ERROR: 'AGENT_SET_ERROR',
  AGENT_REMOVE_ERROR: 'AGENT_REMOVE_ERROR',
  FETCH_AGENTS_REQUEST: 'FETCH_AGENTS_REQUEST',
  FETCH_AGENTS_SUCCESS: 'FETCH_AGENTS_SUCCESS',
  FETCH_AGENTS_FAILURE: 'FETCH_AGENTS_FAILURE',
  REMOVE_FETCH_AGENTS: 'REMOVE_FETCH_AGENTS',
  UPDATE_AGENT_STATUS: 'UPDATE_AGENT_STATUS',
  UPDATE_AGENT_STATUS_ARRAY: 'UPDATE_AGENT_STATUS_ARRAY',
  UPDATE_AGENT_IS_BUSY_STATUS: 'UPDATE_AGENT_IS_BUSY_STATUS',
  DELETE_AGENT_SUCCESS: 'DELETE_AGENT_SUCCESS',
  DELETE_AGENT_FAILURE: 'DELETE_AGENT_FAILURE',
  REMOVE_AGENT_DELETE_SUCCESS_MESSAGE: 'REMOVE_AGENT_DELETE_SUCCESS_MESSAGE',
};

export default agentActionTypes;
